/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const AnnualLeavePurchaseFill = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 120 120">
    <path
      d="M94.98,8.71h-2.83v-3.93C92.15,2.14,90.02,0,87.38,0s-4.77,2.14-4.77,4.77v3.93h-17.84v-3.93C64.77,2.14,62.63,0,60,0s-4.77,2.14-4.77,4.77v3.93h-17.84v-3.93C37.39,2.14,35.25,0,32.62,0s-4.77,2.14-4.77,4.77v3.93h-2.83c-11.38,0-20.67,9.25-20.67,20.67v69.96c0,11.38,9.29,20.67,20.67,20.67h69.96c11.38,0,20.67-9.29,20.67-20.67V29.37c0-11.42-9.29-20.67-20.67-20.67ZM25.02,18.24h2.83v5.46c0,2.63,2.14,4.77,4.77,4.77s4.77-2.14,4.77-4.77v-5.46h17.84v5.46c0,2.63,2.14,4.77,4.77,4.77s4.77-2.14,4.77-4.77v-5.46h17.84v5.46c0,2.63,2.14,4.77,4.77,4.77s4.77-2.14,4.77-4.77v-5.46h2.83c6.14,0,11.13,4.99,11.13,11.13v7.66H13.89v-7.66c0-6.14,4.99-11.13,11.13-11.13ZM92.75,72.3l-17.43-2.7c-.06,0-.1.06-.03.06,3.37,1.02,7.95,4.77,10.05,11.19.57,1.81-1.3,3.5-3.02,2.64l-16.25-7.98c4.55,9.7,6.2,22.42,6.33,35.01h-14.09c2.07-16.57,1.53-29.19.89-35.55l-21.81,14.28c-1.65,1.08-3.78-.41-3.37-2.38,1.37-6.49,5.02-10.65,9.03-13.32l-16.6,5.72c-1.65.57-3.31-.89-2.93-2.61,6.26-27.82,34.63-13.1,34.63-13.1,18.54-17.81,31.74-2.58,36.82,5.37,1.02,1.59-.32,3.66-2.23,3.37Z"
      fill="#21295c"
    />
  </BaseSvgIcon>
)

export default AnnualLeavePurchaseFill
